import React from "react";
import { withAppState } from "../../state";
import { i18n } from "../../services/i18nService";
import { config } from "../../config/config";
import QRCodeReact from "react-qr-code";
import {
  ContentContainer,
  PageWrapper,
  HeaderSection,
  Title,
  Subtitle,
  QRSection,
  DisclaimerList
} from "./styles/Styled";

class MigratingToStarzplay extends React.Component {
  constructor(props) {
    super(props);
    this.onBack = this.onBack.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  onBack() {
    return true;
  }

  render() {
    const {
      applicationState: { userName }
    } = this.props;
    return (
      <PageWrapper>
        <ContentContainer>
          <HeaderSection>
            <Title>{i18n.get("pages.migrate.title")}</Title>
            <Subtitle>{i18n.get("pages.migrate.description")}</Subtitle>
            <Subtitle>{i18n.get("pages.migrate.qrMsg")}</Subtitle>
          </HeaderSection>

          <QRSection>
            <QRCodeReact
              value={`${config.get().sdk.migrationUrl}?username=${userName}&client_type=${config.get().sdk.clientType}`}
              size={398}
            />
          </QRSection>

          <DisclaimerList>
            <li>{i18n.get("pages.migrate.info2")}</li>
            <li>{i18n.get("pages.migrate.info3")}</li>
          </DisclaimerList>
        </ContentContainer>
      </PageWrapper>
    );
  }
}

export default withAppState(MigratingToStarzplay);
